var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDontMissTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 10.6668V8.00016C24.0003 7.29292 23.7194 6.61464 23.2193 6.11454C22.7192 5.61445 22.0409 5.3335 21.3337 5.3335H5.33366C4.62641 5.3335 3.94814 5.61445 3.44804 6.11454C2.94794 6.61464 2.66699 7.29292 2.66699 8.00016V17.3335C2.66699 18.0407 2.94794 18.719 3.44804 19.2191C3.94814 19.7192 4.62641 20.0002 5.33366 20.0002H16.0003M13.3337 25.3335V20.0535V24.2535M9.33366 25.3335H16.0003M24.0003 16.0002H26.667C28.1398 16.0002 29.3337 17.1941 29.3337 18.6668V26.6668C29.3337 28.1396 28.1398 29.3335 26.667 29.3335H24.0003C22.5276 29.3335 21.3337 28.1396 21.3337 26.6668V18.6668C21.3337 17.1941 22.5276 16.0002 24.0003 16.0002Z",
    stroke: "#FAFAFA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDontMissTwo);
export default __webpack_public_path__ + "static/media/dont-miss-two.4c8a580fcea8c6b346e81de13cc5854b.svg";
export { ForwardRef as ReactComponent };